import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "border-0 p-4 pb-0 bg-white rounded-3 mb-4 without-card" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-7 col-md-6" }
const _hoisted_8 = { class: "col-lg-5 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CryptocurrencyWatchList = _resolveComponent("CryptocurrencyWatchList")!
  const _component_MarketPriceStatisticsChart = _resolveComponent("MarketPriceStatisticsChart")!
  const _component_ExchangeCoin = _resolveComponent("ExchangeCoin")!
  const _component_TransactionHistory = _resolveComponent("TransactionHistory")!
  const _component_Portfolio = _resolveComponent("Portfolio")!
  const _component_CryptoRankings = _resolveComponent("CryptoRankings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CryptocurrencyWatchList),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_MarketPriceStatisticsChart)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ExchangeCoin)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_TransactionHistory)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Portfolio)
      ])
    ]),
    _createVNode(_component_CryptoRankings)
  ]))
}